import { GetterTree, MutationTree, Module } from 'vuex';
import {DimensionSecurity} from "../api/ApiClient";
import * as api from "../api/ApiClient";
import { AuthClient } from "../api/ApiClientBase";
import { IExtractHierarchiesInfoInterface, IExtractHierarchyInfo } from '@/components/pages/metadata/Hierarchy/ExtractHierarchiesInterface';
import { getApolloClient, setGraphqlUri } from '@/apollo';
import { GET_EXTRACT_HIERARCHY_DETAILS, GET_EXTRACT_HIERARCHY_INFO } from '@/graphql/ExtractHierarchyQueries';
import { CREATE_EXTRACT_HIERARCHY, DELETE_EXTRACT_HIERARCHY } from '@/graphql/ExtractHierarchyMutation';
import { removeTypename } from "@/utils/cleanTypename";


export interface IExtractHierarchyStore {
    selectedHierarchy: api.ExtractHierarchyDetail | null,
    selectedHierarchyMembers: api.MemberInfo[] | null,
    extractHierarchyInfo: IExtractHierarchyInfo[] | null
}

const ExtractHierarchyStore: Module<IExtractHierarchyStore, any> = {
    namespaced: true,
    state: {
        selectedHierarchy: null,
        selectedHierarchyMembers: null,
        extractHierarchyInfo: null,
    },
    getters: {
        selectedHierarchy:(state: IExtractHierarchyStore) => state.selectedHierarchy,
        selectedHierarchyMembers: (state: IExtractHierarchyStore) => state.selectedHierarchyMembers,
        extractHierarchyInfo: (state: IExtractHierarchyStore) => state.extractHierarchyInfo
    },
    mutations: {
        setSelectedHierarchy(state, selectedHierarchy:  api.ExtractHierarchyDetail ) {   
            state.selectedHierarchy = selectedHierarchy;
        },
        setSelectedHierarchyMembers(state, members: api.MemberInfo[] | null) {
            state.selectedHierarchyMembers = members;
        },
        setExtractHierarchyInfo(state, extractHierarchyInfo: IExtractHierarchyInfo[]) {
             state.extractHierarchyInfo = extractHierarchyInfo;
        }
    },
    actions: {
        // Actions can be added here as needed for hierarchy extraction functionality
        async DeleteHierarchyExtract(context, extractID: number) {

            // var auth_client = new AuthClient();
            // await auth_client.ensureToken();
            // var client = new api.MetadataClient(auth_client);
            // if (!context.state.selectedHierarchy) {
            //     console.log("No selected hierarchy");
            //     throw new Error("No hierarchy selected for deletion.");
            // }
            // console.log("Deleting this:", context.state.selectedHierarchy);
            // const extractID = context.state.selectedHierarchy.extractID;
            // await client.deleteHierarchyExtract(extractID);
            // context.commit('setSelectedHierarchy', null);
            setGraphqlUri(`${AuthClient.configuration.apiBaseUrl}/graphql`);
            const client = getApolloClient();
            const { data } = await client.mutate({
                mutation: DELETE_EXTRACT_HIERARCHY,
                variables: { id: extractID }
            });
            return data.extractHierarchyMutation.deleteHierarchyExtract;
        },

        async getExtractHierarchyInfoList(context){
            setGraphqlUri(`${AuthClient.configuration.apiBaseUrl}/graphql`);
            const client = getApolloClient();
            const { data } = await client.query({
                query: GET_EXTRACT_HIERARCHY_INFO
            });
            const mapToExtractHierarchyInfo = (item: any): IExtractHierarchyInfo => {
                return {
                    extractID: item.id,
                    extractName: item.name
                };
            };
            const items = data.extractHierarchy.extractHierarchyInfo || [];
            const ExtractHierarchyInfoList = items.map(mapToExtractHierarchyInfo);
            context.commit('setExtractHierarchyInfo', ExtractHierarchyInfoList);
            //context.commit('setExtractHierarchyInfo', items);
        },

        async createExtractHierarchy(context, payload:IExtractHierarchiesInfoInterface){
            console.log("Payload for creating extract hierarchy:", payload);
            setGraphqlUri(`${AuthClient.configuration.apiBaseUrl}/graphql`);
            const client = getApolloClient();
            const { data } = await client.mutate({
                mutation: CREATE_EXTRACT_HIERARCHY,
                variables: { extractHierarchyData: payload }
            });
            return data.extractHierarchyMutation.createHierarchyExtract;
        },

        async getExtractHierarchyDetails(context, extractID: number) {
                setGraphqlUri(`${AuthClient.configuration.apiBaseUrl}/graphql`);
            const client = getApolloClient();
            const { data } = await client.query({
                query: GET_EXTRACT_HIERARCHY_DETAILS,
                variables: { extractId: extractID } 
            });
           return data.extractHierarchy.extractHierarchyDetail;
        }
    }
};

export default ExtractHierarchyStore;
